import { makeStyles } from '@material-ui/core';
import { LogoIcon } from './LogoIcon';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
  },
  text: {
    marginLeft: 10,
    fontSize: 20,
    fontWeight: 700,
    // E.ON red, matching the logo mark.
    color: '#e53323',
    whiteSpace: 'nowrap',
  },
});

// Expanded sidebar: the same iPEN logo mark as the collapsed version, kept in
// front of the "iPEN Workbench" wordmark.
export const LogoFull = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <span className={classes.text}>
        <LogoIcon />&nbsp;
        iPEN<br/>Workbench
      </span>
    </div>
  );
};